import { date, showAlert } from '../../../lib/helpers';
import { dataListPaymentType, dataListSettlementStatus, dataListTrxReportStatus, dataListTrxType, dataQrMethod, dataQrType, sof } from '../../../store/params';
import { editedItem, headers, search } from './attributes';


export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    switchCh: true,
    isFirstLoad: true,
    options: {},
    view: false,
    filter: {
      trx_datetime: [],
    },
    dialog: false,
    headers,
    search,
    editedItem,
    selectedRow: '',
    editedIndex: -1,
    filterValue: { trx_datetime: [] },
    filterConfig: [
      { key: 'trx_datetime', type: 'daterange', required: true, props: { label: 'Tanggal Transaksi', includeToday: true, limitRangeTo30Days: true } },
    ]
  }),

  computed: {
    filterData(){
      return [
        { label: 'Bill Number', field: 'bill_num', type: 'text' },
        { label: 'Kode Iuran', field: 'kode_iuran', type: 'text' },
        { label: 'Merchant Name', field: 'merchant_name', type: 'text' },
        { label: 'MID', field: 'mid', type: 'text' },
        { label: 'MPAN', field: 'mpan', type: 'text' },
        { label: 'Reff ID', field: 'rrn', type: 'text' },
        { label: 'QR Method', field: 'qr_method', type: 'select', items: dataQrMethod },
        { label: 'QR Type', field: 'qr_type', type: 'select', items: dataQrType },
        { label: 'Transaction Type', field: 'trx_type', type: 'select', items: dataListTrxType },
        {
          type: 'autocomplete',
          label: 'Issuer Name',
          field: 'issuer_code',
          items: this.itemsIssuer,
          searchInput: this.searchIssuer,
          loading: this.loadingIssuer,
          itemText: 'issuer_name',
          itemValue: 'issuer_code',
        },
        { label: 'Customer PAN', field: 'customer_pan', type: 'text' },
        { label: 'Customer Name', field: 'customer_name', type: 'text' },
        { label: 'Payment Type', field: 'payment_type', type: 'select', items: dataListPaymentType },
        { label: '', field: 'empty_1', type: '' },
        { label: '', field: 'empty_2', type: '' },
        { label: '', field: 'empty_3', type: '' },
        { label: '', field: 'empty_4', type: '' },
        { label: '', field: 'empty_5', type: '' },
        { label: '', field: 'empty_6', type: '' },
        { label: '', field: 'empty_7', type: '' },
        { label: '', field: 'empty_8', type: '' },
        { label: '', field: 'empty_9', type: '' },
        { label: '', field: 'empty_10', type: '' },
        { label: 'Status', field: 'status', type: 'select', items: dataListTrxReportStatus },
        { label: 'Settlement Status', field: 'settlement_status', type: 'select', items: dataListSettlementStatus },
        { label: '', field: 'empty_11', type: '' },
        { label: 'Source of Fund', field: 'payment_method', type: 'select', items: sof },
      ];
    },
    itemsIssuer() {
      return this.$store.state.report.merchantTransaction.allIssuer;
    },
    loadingIssuer() {
      return this.$store.state.report.merchantTransaction.loadingIssuer;
    },
    allData() {
      return this.$store.state.reportBpjstk.allData;
    },
    detailData() {
      return this.$store.state.reportBpjstk.item;
    },
    detailLoading() {
      return this.$store.state.reportBpjstk.itemLoading;
    },
    totalData() {
      return this.$store.state.reportBpjstk.totalData;
    },
    totalPage() {
      return this.$store.state.reportBpjstk.totalPage;
    },
    loading() {
      return this.$store.state.reportBpjstk.loading;
    },

    flashError: {
      get() {
        return this.$store.state.reportBpjstk.flashError;
      },
      set() {
        this.$store.commit('reportBpjstk/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.reportBpjstk.flashErrorMessage;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;

      if (this.checkFilterCh) {
        const filterOn = process.env.VUE_APP_FILTER_DEFAULT;
        const filterOff = filterOn === 'ch' ? 'sql' : 'ch';
        filterCh = this.switchCh ? filterOn : filterOff;
      }

      return filterCh;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('reportBpjstk/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    switchCh: {
      handler() {
        this.clearSearch();
      },
    },
  },
  async mounted() {
    this.getIssuer();
  },
  methods: {
    getTooltipMethod(item) {
      const descriptions = {
        mpm: 'Merchant Presented Mode',
        cpm: 'Customer Presented Mode',
        qristap: 'QRIS NFC'
      };

      const jenis = item.qr_method?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    getTooltipPayement(item) {
      const descriptions = {
        'on us': 'Transaksi pembayaran dalam jaringan BNI',
        'off us': 'Transaksi pembayaran diluar jaringan BNI'
      };

      const jenis = item.payment_type?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    getIssuer() {
      this.$store.dispatch('report/merchantTransaction/getIssuer', {
        date,
      });
    },
    updateSearch(newSearch) {
      this.search.trx_datetime = newSearch.trx_datetime || [];
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.search.trx_datetime = newSearch.trx_datetime || [];
      this.options.page = 1;
      this.getData(); 
    },
    handleSwitch(val) {
      this.switchCh = val;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    showData(val) {
      val.sort();
      this.filter.trx_datetime = val;
      this.search.trx_datetime = val;
      this.getData();
    },

    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('reportBpjstk/clearData');
      } else {
        const source = this.checkEnvCh;
        this.$store.commit('reportBpjstk/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('reportBpjstk/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
            source,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    async viewItem(item) {
      this.view = true;
      const ok = await this.$store.dispatch('reportBpjstk/viewDetail', {
        date,
        id: item.id,
      });
      if (!ok) {
        this.view = false;
        showAlert(this.$store, 'Gagal memuat detail !', 'mdi-alert', 'red');
      }
    },

    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('reportBpjstk/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.bill_num = '';
      this.search.kode_iuran = '';
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.mpan = '';
      this.search.rrn = '';
      this.search.qr_method = '';
      this.search.qr_type = '';
      this.search.trx_type = '';
      this.search.issuer_code = '';
      this.search.customer_pan = '';
      this.search.payment_method = '';
      this.search.customer_name = '';
      this.search.payment_type = '';
      this.search.payment_channel = '';
      this.search.trx_datetime = [];
      this.search.status = '';
      this.search.settlement_status = '';
      this.$nextTick(() => {
        this.$store.commit('reportBpjstk/clearData');
      });
    },

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportBpjstk/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          countData: this.totalData,
          module: 'bpjs-trx',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: this.checkEnvCh,
        });
      }
    },
    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportBpjstk/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('reportBpjstk/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};